<template>
  <div>
    <Lottie :options="iconSand" />
  </div>
</template>
<script lang="ts" src="./in-one-icon.ts"></script>
